import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// agreeDisabled allows parent to control enabling of agree/confirm button (e.g., until checkbox ticked)
const AlertDialog = ({open, onClose, title, description, agreeText, disagreeText, runTaskAndClose, agreeDisabled}) => (
    <Dialog open={open} onClose={onClose}>
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>
            {/* description may be text or a React node */}
            {typeof description === 'string' ? (
                <DialogContentText>{description}</DialogContentText>
            ) : (
                description
            )}
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>{disagreeText || 'Cancel'}</Button>
            <Button onClick={runTaskAndClose} autoFocus disabled={agreeDisabled}>{agreeText || 'OK'}</Button>
        </DialogActions>
    </Dialog>
);
export default AlertDialog;